import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthService } from './../../auth.service';
import { ApiService } from './../../api.service';
import { UserProfileService } from './../../api/user-profile.service';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'iv-auth-callback-page',
  templateUrl: './auth-callback-page.component.html',
  styleUrls: ['./auth-callback-page.component.scss']
})
export class AuthCallbackPageComponent implements OnInit, OnDestroy {

  routeSubscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private apiService: ApiService,
    private userProfileService: UserProfileService,
  ) { }

  ngOnInit() {
    this.routeSubscription = this.activatedRoute.queryParams.subscribe(params => {
      if (params.code) {
        this.apiService.getAuthToken(params.code)
          .pipe(
            map(result => {
              if (result.error) {
                this.router.navigateByUrl('/unauthorized');
              }
              return result;
            })
          )
          .subscribe(response => {
            if (response.jwt) {
              this.authService.setToken(response.jwt);
              this.authService.setPort(response.port);
              this.userProfileService.getEmployeeId()
                .pipe(untilDestroyed(this))
                .subscribe(_response => {
                  if (_response && _response.result) {
                    this.router.navigateByUrl(this.authService.getLastUrl() || '/');
                  }
                });
            } else {
              this.router.navigateByUrl('/unauthorized');
            }
          });
      }
    });
  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

}
